// extracted by mini-css-extract-plugin
module.exports = {"author-content":"styles_author-content__squjc"};